import type { FormatButton } from '../types/formatting-toolbar.types';

export const FORMATTING_BUTTONS: FormatButton[] = [
  {
    id: 'bold',
    icon: 'bold',
    title: 'Bold',
    command: (editor) => { editor.chain().focus().toggleBold().run(); },
    isActive: (editor) => editor.isActive('bold'),
  },
  {
    id: 'italic',
    icon: 'italic',
    title: 'Italic',
    command: (editor) => { editor.chain().focus().toggleItalic().run(); },
    isActive: (editor) => editor.isActive('italic'),
  },
  {
    id: 'heading1',
    icon: 'h-1',
    title: 'Heading 1',
    command: (editor) => { editor.chain().focus().toggleHeading({ level: 1 }).run(); },
    isActive: (editor) => editor.isActive('heading', { level: 1 }),
  },
  {
    id: 'heading2',
    icon: 'h-2',
    title: 'Heading 2',
    command: (editor) => { editor.chain().focus().toggleHeading({ level: 2 }).run(); },
    isActive: (editor) => editor.isActive('heading', { level: 2 }),
  },
  {
    id: 'heading3',
    icon: 'h-3',
    title: 'Heading 3',
    command: (editor) => { editor.chain().focus().toggleHeading({ level: 3 }).run(); },
    isActive: (editor) => editor.isActive('heading', { level: 3 }),
  },
  {
    id: 'paragraph',
    icon: 'text',
    title: 'Paragraph',
    command: (editor) => { editor.chain().focus().setParagraph().run(); },
    isActive: (editor) => editor.isActive('paragraph'),
  },
  {
    id: 'bulletList',
    icon: 'list-unordered',
    title: 'Bullet List',
    command: (editor) => { editor.chain().focus().toggleBulletList().run(); },
    isActive: (editor) => editor.isActive('bulletList'),
  },
  {
    id: 'orderedList',
    icon: 'list-ordered',
    title: 'Numbered List',
    command: (editor) => { editor.chain().focus().toggleOrderedList().run(); },
    isActive: (editor) => editor.isActive('orderedList'),
  },
];
